import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const NotificationsHeader = ({ unreadCount = 0 }) => (
  <Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
      Notifications
    </Typography>
    {/* <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
      You have {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
    </Typography> */}
  </Box>
)

export default NotificationsHeader
